

define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-title/dist/directive', 'components/xo-ui-components/src/message/directive', 'components/xo-address-components/src/add-address/directive', 'components/xo-form-components/src/phone/phoneInput/directive', 'components/xo-form-components/src/dob-nationalid/directive', 'components/xo-ui-components/src/tooltip/directive', 'components/xo-address-components/src/add-address/directive', 'components/xo-models/src/bml/index', 'components/xo-models/src/address/index', 'components/xo-models/src/user/index', 'components/xo-models/src/fi/index', 'components/xo-models/src/auth/index', 'components/xo-models/src/credit/index', 'components/xo-beaver/dist/logger'], function ($, angular, squid, template) {

    return angular.module('xo-bml-apply.directive', ['squid', 'xomodel.checkout', 'xo-title.directive', 'xo-message.directive', 'xo-address-display.directive', 'xo-phone.phoneInput', 'xo-dob-nationalid.directive', 'xo-tooltip.directive', 'xo-add-address.directive', 'xomodel.bml', 'xomodel.address', 'xomodel.user', 'xomodel.fi', 'xomodel.auth', 'beaver']).directive('xoBmlApplyPage', function () {

        return {

            template: template,

            controller: function controller($scope, $rootScope, $state, $locale, $populate, $BillingAddressModel, $BillingAddressesModel, $AuthModel, $ValidateAddressModel, $element, $ValidatePhoneModel, $CheckoutSessionModel, $CheckoutAppDataModel, $BMLStateHandler, $CheckoutCartModel, $CheckoutPayeeModel, $CreditInstallmentModel, $logger, $PatchPhoneModel) {

                $populate($scope, {
                    auth: $AuthModel.instance(),
                    payee: $CheckoutPayeeModel.instance($rootScope.token),
                    billingAddresses: $BillingAddressesModel.instance(),
                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
                    checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
                    checkoutCart: $CheckoutCartModel.instance($rootScope.token),
                    creditOptions: $CreditInstallmentModel.instance($rootScope.token)
                }).then(function () {
                    var defaultBillingAddress = $scope.billingAddresses && $scope.billingAddresses.addresses;
                    defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
                        if (address && address['default'] === true) {
                            return address;
                        }
                    });

                    defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];
                    if (defaultBillingAddress) {
                        $scope.bml.action('napeLookUp', {

                            data: {
                                payer: $scope.checkoutSession.payer,
                                billing_address: {
                                    country: defaultBillingAddress.country,
                                    line1: defaultBillingAddress.line1,
                                    line2: defaultBillingAddress.line2,
                                    city: defaultBillingAddress.city,
                                    state: defaultBillingAddress.state,
                                    postal_code: defaultBillingAddress.postal_code
                                }
                            },

                            success: function success(result) {
                                if (result && result.account_exists === true) {
                                    $scope.bml.nape = 'napePotential';
                                    $scope.bml.fullApplyRequired = false;
                                }
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT() {
                                    // add a log here
                                }
                            }
                        });
                    }

                    if ($scope.billingAddresses && $scope.billingAddresses.addresses && $scope.billingAddresses.addresses.length > 0) {
                        $scope.billingAddresses.addresses.forEach(function (address) {
                            if (address['default']) {
                                $scope.address = billingAddressObject(address);
                                $scope.previousDefaultBillingAddress = address;
                            }
                        });
                    }

                    var bmlData = {
                        reviewUrl: $scope.$parent.reviewUrl,
                        bml: $scope.$parent.bml,
                        bmlApply: $scope.$parent.bmlApply,
                        bmlComplete: $scope.$parent.bmlComplete,
                        checkoutSession: $scope.checkoutSession,
                        auth: $scope.auth,
                        purchase: $scope.checkoutCart.purchase,
                        patchPhone: $scope.patchPhoneModel,
                        billingAddresses: $scope.billingAddresses,
                        merchant: $scope.checkoutAppData.merchant,
                        merchantId: $scope.payee.merchant.id
                    };

                    $scope.bmlStateHandler = new $BMLStateHandler(bmlData);

                    if ($scope.checkoutSession.payer) {
                        $scope.bmlApply.personalInformation.phone.telephone = $scope.checkoutSession.payer.phone;
                        $scope.bmlApply.personalInformation.phone.phoneType = 'MOBILE';
                        // Set mobile as default to prevent unknown type.
                    } else {
                        $scope.bmlFlags.PhoneAdd = true;
                    }
                });

                var $el = $($element);

                $scope.showPhone = function () {
                    return $scope.checkoutSession.payer.phone && $scope.checkoutSession.payer.phone_type === 'WORK';
                };
                $scope.patchPhoneModel = new $PatchPhoneModel();
                $scope.patchPhoneModel.token = $scope.token;

                $scope.init = function () {
                    $scope.checkoutSession.message = null;

                    $scope.previousDefaultBillingAddress = {};
                    $scope.bmlFlags = {};
                    $scope.address = {};
                    $scope.token = $rootScope.token;
                    $scope.countryCode = $locale.country;
                    $scope.validateAddress = new $ValidateAddressModel();
                    $scope.validatePhoneModel = new $ValidatePhoneModel();
                    $scope.validatePhoneModel.token = $scope.token;

                    $scope.bmlFlags.billingAddressUpdated = false;
                    $scope.bmlFlags.AddressAdd = false;
                    $scope.bmlFlags.AddressDisplay = true;
                    $scope.bmlFlags.PhoneAdd = false;
                    $scope.bmlFlags.ChangeLink = true;
                    $scope.billingAddressUpdated = false;

                    $('.paypalHeaderWrapper').addClass('paypalCredit');
                    $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
                    $('.paypalHeader').addClass('span14');
                    $('.paypalHeader').removeClass('span24');

                    if ($scope.bml && $scope.bml.application_status === 'SOFT_DECLINED') {
                        $scope.checkoutSession.message = {
                            type: 'warning',
                            msgKeys: ['applyForBml.bmlDeclineSoft']
                        };
                    }
                    $logger.info('APPLYFORBML_VIEW_RENDER');
                };

                $scope.redirectToReview = function () {
                    $scope.bmlStateHandler.payInFullRedirect();
                };

                $scope.onContinue = function () {
                    if ($scope.validateLegalAge()) {
                        if ($scope.bmlFlags.billingAddressUpdated) {
                            $scope.validateBillingAddress();
                        } else {
                            triggerNextState();
                        }
                    }
                };

                $scope.validateLegalAge = function () {
                    var dobMonth = $scope.bmlApply.personalInformation.month,
                        dobDay = $scope.bmlApply.personalInformation.day,
                        dobYear = $scope.bmlApply.personalInformation.year,
                        currentDate = new Date(),
                        currentMonth = currentDate.getMonth() + 1,
                        currentDay = currentDate.getDate(),
                        currentYear = currentDate.getFullYear(),
                        largestDOBYear = currentYear - 18; // Legal Age is 18

                    var isLegal = dobYear < largestDOBYear || dobYear === largestDOBYear && dobMonth < currentMonth || // eslint-disable-line no-extra-parens
                    dobYear === largestDOBYear && dobMonth === currentMonth && dobDay <= currentDay; // eslint-disable-line no-extra-parens

                    if (!isLegal) {
                        handleDobValidation();
                    }

                    return isLegal;
                };

                function handleDobValidation() {
                    var $fields = $('#dobSelect .dropdown select');
                    $fields.addClass('backendError');
                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }
                }

                function triggerNextState() {
                    $logger.info('APPLYFORBML_VIEW_SUBMIT');
                    if ($scope.bml.nape === 'napePotential') {
                        $scope.bmlStateHandler.applyBML();
                    } else {
                        $scope.checkoutSession.message = null;
                        $scope.bmlStateHandler.termsAndCondition();
                    }
                }

                $scope.changeAddress = function () {

                    $scope.bmlFlags.billingAddressUpdated = true;
                    $scope.bml.phoneChanged = true;
                    $scope.bmlFlags.AddressAdd = true;
                    $scope.bmlFlags.AddressDisplay = false;
                    $scope.bmlFlags.PhoneAdd = true;
                    $scope.bmlFlags.ChangeLink = false;
                };

                $scope.changePlan = function () {
                    $state.go('checkout.chooseCreditOffer');
                };

                $scope.validateBillingAddress = function () {
                    var newBilling = billingAddressObject($scope.address);
                    newBilling['default'] = true;
                    $scope.previousDefaultBillingAddress['default'] = false;
                    $scope.validatePhoneModel.save({
                        data: {
                            telephone: $scope.bmlApply.personalInformation.phone.telephone,
                            phoneType: $scope.bmlApply.personalInformation.phone.phoneType
                        },
                        success: function success(result) {

                            if (result) {
                                newBilling.save({
                                    data: $scope.billingAddress,

                                    success: function success() {
                                        $scope.updateBillingAddress(newBilling);
                                    },

                                    validation: function validation(res) {
                                        handleValidation(res);
                                    }
                                });
                            } else {
                                handlePhoneValidation(result);
                            }
                        },
                        validation: function validation(result) {
                            handlePhoneValidation(result);
                        }
                    });
                };

                $scope.updateBillingAddress = function (newBillingAddress) {
                    var addresses = $scope.billingAddresses.addresses;
                    if (!isUserInputtedAddress(addresses[0])) {
                        addresses.unshift(newBillingAddress);
                    } else {
                        addresses[0] = newBillingAddress;
                    }
                    triggerNextState();
                };

                function isUserInputtedAddress(address) {
                    return address.id === '0';
                }

                function handleValidation(res) {
                    if (res && res.fields && res.fields.length) {
                        res.fields.forEach(function (field) {
                            if (field.field) {
                                var $field = $($el.find('[name="' + field.field + '"]'));
                                $field.addClass('backendError');
                            }
                        });
                    }

                    $scope.checkoutSession.message = {
                        type: 'error',
                        msgKeys: ['genericError.incontextGenericPageError']
                    };

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }
                }

                function handlePhoneValidation() {
                    var $field = $('.telephone');
                    $field.addClass('backendError');
                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }
                }

                function billingAddressObject(address) {
                    return new $BillingAddressModel({
                        line1: address.line1,
                        line2: address.line2,
                        city: address.city,
                        state: address.state,
                        postal_code: address.postal_code,
                        country: $scope.countryCode,
                        full_address: address.full_address,
                        id: '0'
                    });
                }

                $scope.init();
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/bml-display/xo-bml-apply/directive.js
// module id = ./components/xo-credit-components/src/bml-display/xo-bml-apply/directive.js
// module chunks = 1